import { userActions, verifyScope } from "dashboard-utils/lib";
import { format } from "date-fns";

export const isActiveRoute = (path) => {
  const pathName = window.location.pathname;
  if (path === "/business") {
    return path === pathName;
  }
  return pathName.includes(path);
};

export const getFinalSection = (
  sections = [],
  merchantInfo = {},
  userScopes = [],
  forceShowTabs = [],
  isConsolidatedDashboard = false,
  merchantParams = {},
  isMobile = false,
  isTablet = false,
) => {
  const finalMenuItem = [];
  let activeMenu = "";
  sections.forEach((section, index) => {
    const finalItems = [];
    if (
      !section?.enablementKey ||
      forceShowTabs.includes(section?.enablementKey) ||
      merchantInfo?.[section?.enablementKey]
    ) {
      if (section.id === "diagnostic-tool") {
        section.hidden = isMobile || isTablet;
      }
      section.items.forEach((item) => {
        if (
          item.id === "payment_tools" &&
          merchantInfo?.integrationType === "Tools"
        ) {
          if (isConsolidatedDashboard) {
            item.expanded = false;
            item.items = null;
          } else {
            item.expanded = true;
          }
        }
        if (
          !item?.enablementKey ||
          forceShowTabs.includes(item?.enablementKey) ||
          merchantInfo?.[item?.enablementKey]
        ) {
          if (isActiveRoute(item.path)) {
            activeMenu = item.text;
            item.active = true;
          } else {
            item.active = false;
          }
          if (item?.verifyAccess && !isConsolidatedDashboard) {
            item.isRestricted = !verifyScope({
              action: item.verifyAccess.action,
              userScopes,
              matchAny: item.verifyAccess.matchAny,
            });
            item.restrictedMessage = item.verifyAccess.message;
          } else {
            item.isRestricted = isConsolidatedDashboard && !item.isConsolidateCompatible;
            if(merchantParams.isMccAccount) {
              item.isRestricted = !item.isMCCCompatible;
            }
          }
          if (item.items) {
            item.items.forEach((i) => {
              if (isActiveRoute(i.path)) {
                activeMenu = i.text;
                i.active = true;
                item.expanded = true;
                item.active = true;
              } else {
                i.active = false;
              }
              if (i?.verifyAccess && !isConsolidatedDashboard) {
                i.isRestricted = !verifyScope({
                  action: i.verifyAccess.action,
                  userScopes,
                  matchAny: i.verifyAccess.matchAny,
                });
                i.restrictedMessage = i.verifyAccess.message;
              } else {
                i.isRestricted = isConsolidatedDashboard && !i.isConsolidateCompatible;
                if(merchantParams.isMccAccount) {
                  i.isRestricted = !i.isMCCCompatible;
                }
              }
            });
          }
          finalItems.push(item);
        }
      });
      if (index === sections.length - 2) {
        section.hideBottomBorder = false;
      }
      section.items = finalItems;
      finalMenuItem.push(section);
    }
  });
  return { finalMenuItem, activeMenu };
};

// formate date to dd/mm/yyyy using date-fns
export const getFormattedDate = (date, dateFormat = "d LLL''yy") => {
  if (!date) return "--";
  try {
    const d = format(new Date(date), dateFormat);
    return d;
  } catch {
    return "--";
  }
};

// get time from date using date-fns
export const getFormattedTime = (date, timeFormat = "hh:mm a") => {
  if (!date) return "--";
  try {
    const d = format(new Date(date), timeFormat);
    return d;
  } catch {
    return "--";
  }
};

export const parseForFlags = (result) => {
  let flags = {};
  const currencyMidMap = {}
  const baseCurrencies = {};
  result?.forEach((elem) => {
    if (elem.active == true) {
      if(elem.key === 'baseCurrency') {
        currencyMidMap[elem.merchantId] = elem.value || null;
        if(baseCurrencies[elem.value]) {
          baseCurrencies[elem.value]++
        } else {
          baseCurrencies[elem.value] = 1;
        }
      } 
      flags[elem['key']] = elem['value'];
    }
  });
  
  flags.isMccAccount = Object.keys(baseCurrencies).length > 1;
  flags.currencyMidMap = currencyMidMap;
  return flags;
}
